export const appealEmailStatus = {
  PENDING: 5693,
  NOT_SCHEDULED: 5695,
  SENT: 5692,
  CANCELLED: 5694,
};

export const appealStatus = {
  PENDING: 5696,
  IN_PROGRESS: 5697,
  COMPLETE: 5698,
  CANCELLED: 5699,
  NOT_SCHEDULED: 5700,
};

export const attendanceMethod = {
  EMAIL: 6323,
  PHONE: 6322,
};

export const californiaBillingOptions = {
  GOOD_STANDING: 5780,
  WARNING_CA_BILLING_ADDRESS: 5781,
  WARNING_NON_CA_BILLING_ADDRESS: 5782,
  NOT_IN_GOOD_STANDING_CA_BILLING_ADDRESS: 5783,
  NOT_IN_GOOD_STANDING_NON_CA_BILLING_ADDRESS: 5784,
};

export const campaignStatus = {
  CREATED: 5464,
  SUBMITTED: 5465,
  APPROVED_FUTURE: 5467,
  PUBLISHED: 5507,
  EXPIRED: 5508,
  DECLINED: 5466,
  DEACTIVATED: 5468,
  SUBMITTED_AWAITING_REVIEW: 6238,
  FUTURE: 6239,
};

export const canadianProvince = {
  SK: 5657,
  NL: 5652,
  NU: 5659,
  ON: 5654,
  BC: 5649,
  QC: 5656,
  NB: 5651,
  YT: 5658,
  NS: 5653,
  AB: 5648,
  NT: 5660,
  PE: 5655,
  MB: 5650,
};

export const civicoreUserType = {
  PEER_REVIEWER: 5639,
  PROJECT_MANAGER: 5638,
};

export const companyGivingStatus = {
  PENDING_APPROVAL: 6432,
  PENDING_PROFILE: 6433,
  APPROVED: 6434,
};

export const companyGivingVerificationType = {
  EMPLOYEE_ID: 6435,
  COMPANY_CODE: 6436,
  NONE: 6437,
};

export const companyGivingUserProfileStatus = {
  PENDING: 6440,
  ACTIVE: 6441,
};

export const country = {
  AFGANISTAN: 1049,
  ALAND_ISLANDS: 1074,
  AMERICAN_SAMOA: 1055,
  ARUBA: 5704,
  AUSTRALIA: 1050,
  AUSTRIA: 5705,
  BAHAMAS: 5706,
  BAHRAIN: 1053,
  BANGLADESH: 1962,
  BELGIUM: 1051,
  BELIZE: 5707,
  BERMUDA: 1052,
  BRAZIL: 1054,
  BRITISH_VIRGIN_ISLANDS: 5708,
  BRUNEI: 5709,
  CANADA: 937,
  CAYMAN_ISLANDS: 5710,
  CHINA: 5683,
  COSTA_RICA: 1057,
  CROATIA: 5711,
  CONGO: 5712,
  DENMARK: 1058,
  EGYPT: 5713,
  FINLAND: 5662,
  FRANCE: 1060,
  GEORGIA: 5688,
  GERMANY: 1059,
  GREENLAND: 5714,
  HONG_KONG: 1062,
  ICELAND: 5715,
  INDIA: 5674,
  IRELAND: 1063,
  ISRAEL: 1064,
  ITALY: 1065,
  IVORY_COAST: 5685,
  JAPAN: 5686,
  KENYA: 5716,
  KOREA: 3920,
  KUWAIT: 5717,
  LIECHTENSTEIN: 5718,
  LITHUANIA: 5719,
  LUXEMBOURG: 1066,
  MACAU: 5720,
  MADAGASCAR: 5721,
  MALAYSIA: 5722,
  MALTA: 5723,
  MAURITIUS: 5724,
  MEXICO: 938,
  MONACO: 5725,
  MOZAMBIQUE: 5726,
  NETHERLANDS: 1068,
  NEW_ZEALAND: 1069,
  NIGERIA: 1961,
  NORTHERN_MARIANA_ISLANDS: 1067,
  NORWAY: 3842,
  PANAMA: 5727,
  POLAND: 5728,
  PORTUGAL: 5329,
  PUERTO_RICO: 5729,
  QATAR: 5730,
  ROMANIA: 1963,
  SAN_MARINO: 5731,
  SAUDI_ARABIA: 5676,
  SINGAPORE: 5328,
  SLOVAKIA: 1071,
  SLOVENIA: 5732,
  SOUTH_AFRICA: 5661,
  SPAIN: 1070,
  SWEDEN: 5684,
  SWITZERLAND: 1056,
  TAIWAN: 5675,
  TANZANIA: 5733,
  THAILAND: 1072,
  TURKEY: 5779,
  UKRAINE: 5687,
  UNITED_ARAB_EMIRATES: 5677,
  UNITED_KINGDOM: 1061,
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: 1073,
  UNITED_STATES_OF_AMERICA: 936,
  URUGUAY: 3844,
  ZAMBIA: 5734,
  ZIMBABWE: 5735,
  NICARAGUA: 6206,
  DOMINICAN_REPUBLIC: 6205,
};

export const donationType = {
  EARLY_GIVING_DONATION: 5482,
  ONE_TIME_DONATION: 5480,
  RECURRING_DONATION: 5481,
};

export const donationAnonymousStatus = {
  NOT_ANONYMOUS: 987,
  PUBLICLY_ANONYMOUS: 988,
  COMPLETELY_ANONYMOUS: 986,
};

export const emailRecipient = {
  DONOR: 5489,
  ORGANIZATION_ADMIN: 5487,
  SYSTEM_ADMIN: 5488,
  FUNDRAISING_PAGE_CREATOR: 5493,
  ECARD_PURCHASER: 5537,
  P2P_PAGE_CREATOR: 6258,
  ECARD_RECIPIENT: 5536,
  CAMPAIGN_CREATOR: 6421,
};

export const emailType = {
  ORGANIZATION_REGISTRATION_PROCESS: 5491,
  DONATION_RECEIPT: 5490,
  NOTIFICATION: 5492,
  FUNDRAISING_PAGE_NOTIFICATIONS: 5494,
  ECARDS: 5535,
  COMPANY_GIVING: 6242,
  ORGANIZATION_APPROVAL_PROCESS: 5858,
  REPEAT_YOUR_DONATION: 5860,
  GIVING_ECARDS: 6241,
  ORGANIZATION_INQUIRY_PROCESS: 5857,
  CAMPAIGN_APPROVAL_PROCESS: 5859,
  CAMPAIGN_MANAGEMENT: 6240,
};

export const endRecurringAfter = {
  DATE: 928,
  PAYMENTS: 929,
  TOTAL_AMOUNT: 930,
  NEVER: 931,
};

export const eventModality = {
  IN_PERSON: 6188,
  VIRTUAL: 6187,
  HYBRID: 6189,
};

export const fileTags = {
  GIVES_DAY: 5510,
  NONPROFIT_TOOLBOX: 5515,
  DONOR_CONTENT: 5516,
  ADMINISTRATIVE_CONTENT: 5527,
  INQUIRY_CONTENT: 5528,
  HOME_PAGE: 5543,
  COMPANY_GIVING: 6439,
  CONTENT_FEED: 5644,
};

export const givesDayPrizeIcon = {
  HOURLY: 5398,
  PARTICIPATION: 5399,
};

export const dedicationType = {
  IN_HONOR_OF: 6191,
  IN_MEMORY_OF: 6190,
};

export const manualDonationType = {
  CASH: 5680,
  OTHER: 5682,
  CHECK: 5679,
  DAF: 5681,
};

export const matchFundType = {
  DONATION_COUNT_BASED: 6320,
  DONATION_AMOUNT_BASED: 6321,
};

export const mode = {
  YEAR_ROUND: 5594,
  COUNTDOWN: 5589,
  GIVES_DAY: 5591,
  POST: 5593,
  SCHEDULING: 5590,
  GIVES_DAY_END: 5592,
};

export const multimediaType = {
  YOUTUBE: 5472,
  PICTURE: 5471,
  VIMEO: 5551,
};

export const paymentAccountType = {
  GIVING_E_CARD: 5530,
  EMPLOYEE_GIVING_ACCOUNT: 5532,
  DONOR_ADVISED_FUNDS: 5531,
};

export const paymentMethod = {
  CREDIT_CARD: 5564,
  BANK_ACCOUNT: 5538,
  GIVING_E_CARD: 934,
  SAVED_PROFILE: 935,
  MANUAL_ENTRY_REGISTRATION_FEES: 5546,
  GIVING_ECARD: 6279,
};

export const recurFreq = {
  WEEKLY: 914,
  MONTHLY: 915,
  QUARTERLY: 916,
  YEARLY: 917,
  OTHER: 927,
};

export const state = {
  AL: 2,
  AK: 3,
  AZ: 4,
  AR: 5,
  CA: 6,
  CO: 1,
  CT: 7,
  DE: 8,
  DC: 9,
  FL: 10,
  GA: 11,
  HI: 12,
  ID: 13,
  IL: 14,
  IN: 15,
  IA: 16,
  KS: 17,
  KY: 18,
  LA: 19,
  ME: 20,
  MD: 21,
  MA: 22,
  MI: 23,
  MN: 24,
  MS: 25,
  MO: 26,
  MT: 27,
  NE: 28,
  NV: 29,
  NH: 30,
  NJ: 31,
  NM: 32,
  NY: 33,
  NC: 34,
  ND: 35,
  OH: 36,
  OK: 37,
  OR: 38,
  PA: 39,
  PR: 5678,
  RI: 41,
  SC: 42,
  SD: 43,
  TN: 44,
  TX: 45,
  UT: 46,
  VT: 47,
  VA: 48,
  WA: 49,
  WV: 50,
  WI: 51,
  WY: 52,
};

export const yesNo = {
  YES: 426,
  NO: 427,
};
